"use client";

import { CSSProperties } from "react";
import { UStyles } from "@/app/utils/UStyles";
import { FlowNodeData } from "./ProjectFlow.logic";
import styles from "./ProjectFlow.module.css";

type Props = {
  node: FlowNodeData;
  index: number;
  onNavigate: (path: string) => void;
};

export default function FlowOrbNode(props: Props) {
  const { node, index, onNavigate } = props;
  const [x, y] = node.position;

  const nodeStyle = {
    left: `${x}%`,
    top: `${y}%`,
    "--float-delay": `${index * 0.7}s`,
  } as CSSProperties;

  return (
    <button
      type="button"
      className={styles.node}
      style={nodeStyle}
      onClick={() => onNavigate(node.path)}
    >
      <span className={styles.orb}>
        <span
          className={UStyles.classNames(
            styles.dot,
            node.reached ? styles.dotReached : styles.dotIdle,
          )}
        >
          <span className={styles.count}>{node.count}</span>
        </span>
      </span>

      <span className={styles.label}>{node.label}</span>
    </button>
  );
}
